import styled from "styled-components";
import React, { useEffect, useState } from "react";
import SplashScreen from "../features/auth/SplashScreen";
import LoginForm from "../features/auth/LoginScreen";
import { Toaster } from "react-hot-toast";
import { Navigate, useNavigate } from "react-router-dom";
import { routesPermission } from "../utils/constant";

// Styled container for the entire page
const PageContainer = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const LogoContainer = styled.div`
  position: absolute;
  top: ${(props) => (props.logoUp ? "20%" : "50%")};
  transform: ${(props) =>
    props.logoUp ? "translateY(-50%) scale(1)" : "translateY(-50%) scale(1)"};
  transition: top 1.5s ease, transform 1.5s ease;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// Styled container for the login form with transition
const FormContainer = styled.div`
  position: absolute;
  bottom: ${(props) => (props.formVisible ? "0%" : "-50%")};
  opacity: ${(props) => (props.formVisible ? 1 : 0)};
  transition: bottom 1.5s ease, opacity 1.5s ease;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Login = () => {
  const navigate = useNavigate();

  const [logoUp, setLogoUp] = useState(false);
  const [formVisible, setFormVisible] = useState(false);

  useEffect(() => {
    const logoTimeout = setTimeout(() => {
      setLogoUp(true); // Move logo up
    }, 2000); // Wait 2 seconds before moving the logo up

    const formTimeout = setTimeout(() => {
      setFormVisible(true); // Show the login form
    }, 2000); // Wait 3 seconds before showing the login form

    return () => {
      clearTimeout(logoTimeout);
      clearTimeout(formTimeout);
    };
  }, []);
 
  useEffect(() => {
    const role = localStorage.getItem("role");
    const firstRoute = routesPermission[role]?.[0] ?? "/login";
    if (role) {
      navigate(firstRoute);
    }
  }, []);

  useEffect(() => {
    const role = localStorage.getItem("role");
    const firstRoute = role ? routesPermission[role][0] : "/login";
    if (role) {
      navigate(firstRoute);
    }
  }, []);

  return (
    <>
      <Toaster position="top-right" />
      <PageContainer>
        <LogoContainer logoUp={logoUp}>
          <SplashScreen logoUp={logoUp} />
        </LogoContainer>
        <FormContainer formVisible={formVisible}>
          <LoginForm />
        </FormContainer>
      </PageContainer>
    </>
  );
};

export default Login;
